export default __webpack_public_path__ + "static/media/group-608.082418a1.png";